<template>
  <li>
    <div class="text">
      <h3 class="writer">{{comment.writer}}</h3>
      <p>{{comment.text}}</p>
      <a href="#" class="delete" :style="deleteStyle" @click.prevent="toggleDeletePanel">
        <img src="@/assets/img/comment_del.png" alt="댓글 삭제" />
      </a>
    </div>
    <div class="alertM" :style="panelStyle">
      <p>삭제하시겠습니까?</p>
      <div class="btnWrap">
        <a href class="submit" @click.prevent="confirm">확인</a>
        <a href class="cancel" @click.prevent="cancel1">취소</a>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: ["comment", "qna_id"],
  data() {
    return {
      togglePanel: false
    };
  },
  computed: {
    deleteStyle() {
      if (this.comment.writer === localStorage.getItem("default_info")) {
        return "display:block";
      } else {
        return "display:none";
      }
    },
    panelStyle() {
      return this.togglePanel ? "display:block" : "display:none";
    }
  },
  methods: {
    toggleDeletePanel() {
      this.togglePanel = !this.togglePanel;
    },
    cancel1() {
      this.togglePanel = !this.togglePanel;
    },
    confirm() {
      let url = this.$Constant.QnaCommentApi;
      let $self = this;
      this.$axios.delete(`${url}/${this.comment.id}`).then(() => {
        let qna_id = this.qna_id;
        $self.$store.dispatch("loadQnaView", qna_id);
      });
    }
  }
};
</script>


<style lang="scss" scoped>
</style>